import { BADGE_META } from "../../lib/constants";

/**
 * Smart badge with Lucide icon - NO emojis.
 */
export default function SmartBadge({ type, size = "md" }) {
    const meta = BADGE_META[type];
    if (!meta) return null;
    const Icon = meta.icon;
    const sizing = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
    return (
        <span
            data-testid={`smart-badge-${type}`}
            className={`inline-flex items-center gap-1.5 rounded-full font-bold border bg-gradient-to-r ${meta.color} ${sizing}`}
        >
            <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} strokeWidth={2.4} />
            {meta.label}
        </span>
    );
}
